import { UserProfile } from '@clerk/clerk-react';

import { SoftCard } from '@/components/ui/soft-card';
import { SettingsHeader } from './components/SettingsHeader';

export function Security() {
	return (
		<div className="max-w-3xl space-y-8">
			<SettingsHeader
				eyebrow="Account"
				title="Security"
				description="Password, two-factor authentication and active sessions. Managed through your Unify account."
			/>

			<SoftCard className="!p-3 md:!p-3">
				<UserProfile routing="hash" />
			</SoftCard>
		</div>
	);
}
